import {
  FETCH_EXPERIENCES_REQUEST,
  FETCH_EXPERIENCE_REQUEST,
  CLEAR_SEARCH,
} from './experienceActionTypes';

export const fetchExperiences = (search) => ({
  type: FETCH_EXPERIENCES_REQUEST,
  search,
});
export const fetchExperience = (slug) => ({
  type: FETCH_EXPERIENCE_REQUEST,
  slug,
});
export const clearSearch = { type: CLEAR_SEARCH };
